<template>
  <div>
    <div class="p-businessMain">
      <div class="p-businessMainInner">
        <div class="p-businessMainHeading">
          <h2 class="p-businessMainHeading_title">
            あなたのチームに<br>
            プロフェッショナルを
          </h2>
          <p class="p-businessMainHeading_text">
            日本最大級のスキルマーケット<br>
            業界プロ水準のスキルを<br class="isSP">比べて、選んで、あなたのビジネスに
          </p>
          <div
            class="p-businessMainBtnWrapper"
            ref="accountButton"
          >
            <DButton
              v-if="isShowMultipleButton"
              class="p-businessMainHeading_button-multiple"
              :nuxt-link-to="userOuterFlowButton.REGISTER.link"
              type="contained"
              color="primary"
              size="large"
              is-bold
            >
              {{ userOuterFlowButton.REGISTER.text }}
            </DButton>
            <!-- 常に表示される -->
            <!-- CSR遷移だとアンケート未回答の状態でもビジネストップ画面などを閲覧できてしまうため、SSRでnuxtServerInitを通し、アクセス許可対象のwhiteListチェックが必須 -->
            <DButton
              :class="isShowMultipleButton ? 'p-businessMainHeading_button-multiple' : 'p-businessMainHeading_button-single'"
              type="outlined"
              color="primary"
              size="large"
              :href="linkSettings[accountPattern].businessService.link"
              pattern="reverse"
              is-bold
            >
              {{ linkSettings[accountPattern].businessService.text }}
            </DButton>
          </div>
          <div class="p-businessMainLinkWrapper isSP">
            <p
              v-if="linkSettings[accountPattern].isProviderOrPrivateBuyer"
              class="p-businessMainLinkWrapper_text p-businessMainLinkWrapper_text-link"
            >
              <a
                class="p-businessMain-link"
                href="/"
              >出品・プライベート購入の方はこちら</a>
            </p>
          </div>
        </div>
        <div class="p-businessMainImageWrapper isPC">
          <ul class="p-businessMainImageList">
            <li class="p-businessMainImageList_item">
              <img
                :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/hero_card_01.png')"
                alt="グラフィックデザイナー"
                width="232"
                height="342"
                loading="lazy"
              >
            </li>
            <li class="p-businessMainImageList_item">
              <img
                :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/hero_card_02.png')"
                alt="webデザイナー"
                width="232"
                height="342"
                loading="lazy"
              >
            </li>
            <li class="p-businessMainImageList_item">
              <img
                :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/hero_card_03.png')"
                alt="動画クリエイター"
                width="232"
                height="342"
                loading="lazy"
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="p-businessMainImageWrapper isSP">
        <ul class="p-businessMainImageList">
          <li class="p-businessMainImageList_item">
            <img
              :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/hero_card_01.png')"
              alt="グラフィックデザイナー"
              width="191"
              height="280"
              loading="lazy"
            >
          </li>
          <li class="p-businessMainImageList_item">
            <img
              :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/hero_card_02.png')"
              alt="webデザイナー"
              width="191"
              height="280"
              loading="lazy"
            >
          </li>
          <li class="p-businessMainImageList_item">
            <img
              :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/hero_card_03.png')"
              alt="動画クリエイター"
              width="191"
              height="280"
              loading="lazy"
            >
          </li>
        </ul>
      </div>
      <div class="p-businessMainDownload">
        <img
          class="p-businessMainDownload_image isPC"
          :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/introduction_document.png')"
          alt="紹介資料"
          width="138"
          height="53"
          loading="lazy"
        >
        <p class="p-businessMainDownload_text">導入メリットや機能など詳しく知りたい方へ</p>
        <DButton
          class="p-businessMainDownload_button"
          :href="userOuterFlowButton.DOWNLOAD.link"
          type="outlined"
          color="primary"
          size="large"
          is-bold
          target="_blank"
          rel="noopener"
        >
          {{ userOuterFlowButton.DOWNLOAD.text }}
        </DButton>
      </div>
    </div>
    <div class="p-businessSponsor">
      <p class="p-businessSponsorHeading">
        様々な企業で新しいビジネスの<br class="isSP">コラボレーションが生まれています
      </p>
      <ul class="p-businessSponsorList">
        <li class="p-businessSponsorList_item">
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/ana.png')"
            class="isPC"
            alt="ana"
            width="400"
            height="96"
            loading="lazy"
          >
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/ana.png')"
            class="isSP"
            alt="ana"
            width="200"
            height="77"
            loading="lazy"
          >
        </li>
        <li class="p-businessSponsorList_item">
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/panasonic.png')"
            class="isPC"
            alt="panasonic"
            width="400"
            height="96"
            loading="lazy"
          >
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/panasonic.png')"
            class="isSP"
            alt="panasonic"
            width="200"
            height="77"
            loading="lazy"
          >
        </li>
        <li class="p-businessSponsorList_item">
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/recruit.png')"
            class="isPC"
            alt="recruit"
            width="400"
            height="96"
            loading="lazy"
          >
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/recruit.png')"
            class="isSP"
            alt="recruit"
            width="200"
            height="77"
            loading="lazy"
          >
        </li>
        <li class="p-businessSponsorList_item">
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sumitomo_seimei.png')"
            class="isPC"
            alt="住友生命"
            width="400"
            height="96"
            loading="lazy"
          >
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/sumitomo_seimei.png')"
            class="isSP"
            alt="住友生命"
            width="200"
            height="77"
            loading="lazy"
          >
        </li>
        <li class="p-businessSponsorList_item">
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/ca.png')"
            class="isPC"
            alt="cyberagent"
            width="400"
            height="96"
            loading="lazy"
          >
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/ca.png')"
            class="isSP"
            alt="cyberagent"
            width="200"
            height="77"
            loading="lazy"
          >
        </li>
        <li class="p-businessSponsorList_item">
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/tokyu.png')"
            class="isPC"
            alt="東急"
            width="400"
            height="96"
            loading="lazy"
          >
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/tokyu.png')"
            class="isSP"
            alt="東急"
            width="200"
            height="77"
            loading="lazy"
          >
        </li>
        <li class="p-businessSponsorList_item">
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/shimizukensetsu.png')"
            class="isPC"
            alt="清水建設"
            width="400"
            height="96"
            loading="lazy"
          >
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/shimizukensetsu.png')"
            class="isSP"
            alt="清水建設"
            width="200"
            height="77"
            loading="lazy"
          >
        </li>
        <li class="p-businessSponsorList_item">
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/gmo.png')"
            class="isPC"
            alt="gmo"
            width="400"
            height="96"
            loading="lazy"
          >
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/gmo.png')"
            class="isSP"
            alt="gmo"
            width="200"
            height="77"
            loading="lazy"
          >
        </li>
        <li class="p-businessSponsorList_item">
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/plaid.png')"
            class="isPC"
            alt="plaid"
            width="400"
            height="96"
            loading="lazy"
          >
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/plaid.png')"
            class="isSP"
            alt="plaid"
            width="200"
            height="77"
            loading="lazy"
          >
        </li>
        <li class="p-businessSponsorList_item">
          <img
            src="~assets/images/pages/business/lp/daiwa.png"
            class="isPC"
            alt="大和証券"
            width="400"
            height="96"
            loading="lazy"
          >
          <img
            src="~assets/images/pages/business/lp/sp/daiwa.png"
            class="isSP"
            alt="大和証券"
            width="200"
            height="77"
            loading="lazy"
          >
        </li>
        <li class="p-businessSponsorList_item">
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/saizeriya.png')"
            class="isPC"
            alt="saizeria"
            width="400"
            height="96"
            loading="lazy"
          >
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/saizeriya.png')"
            class="isSP"
            alt="saizeria"
            width="200"
            height="77"
            loading="lazy"
          >
        </li>
        <li class="p-businessSponsorList_item">
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/aioinissaydowa.png')"
            class="isPC"
            alt="あいおいニッセイ同和損害保険"
            width="400"
            height="96"
            loading="lazy"
          >
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/aioinissaydowa.png')"
            class="isSP"
            alt="あいおいニッセイ同和損害保険"
            width="200"
            height="77"
            loading="lazy"
          >
        </li>
      </ul>
    </div>
    <div class="p-businessAbout">
      <div class="p-businessAbout_inner p-businessMaxWidthContainer">
        <div class="p-businessAboutImageWrapper isPC">
          <img
            :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/about.png')"
            alt="about"
            width="326"
            height="322"
            loading="lazy"
          >
        </div>
        <div class="p-businessAboutContent">
          <h2 class="p-businessAboutContent_subtitle">About</h2>
          <p class="p-businessAboutContent_title">
            ビジネス向けに特化した<br>
            サービス購入<br class="isSP">プラットフォーム
          </p>
          <div class="p-businessAboutImageWrapper isSP">
            <img
              :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/about.png')"
              alt="about"
              width="326"
              height="322"
              loading="lazy"
            >
          </div>
          <p class="p-businessAboutContent_text">
            利用者数{{ CONSTANTS_TEXT.USER_NUMBER }}人、出品サービス数40万件のスキルマーケット、ココナラ。<br>
            ココナラビジネスではその中からビジネス向けのサービスを集めました。{{ CONSTANTS_TEXT.CATEGORY_NUMBER }}種類以上の豊富なカテゴリから、ご依頼のニーズに合わせて比較検討しご利用ください。
          </p>
          <!-- CSR遷移だとアンケート未回答の状態でもビジネストップ画面などを閲覧できてしまうため、SSRでnuxtServerInitを通し、アクセス許可対象のwhiteListチェックが必須 -->
          <DButton
            class="p-businessAboutButton"
            :href="linkSettings[accountPattern].businessService.link"
            type="outlined"
            color="primary"
            size="large"
            is-bold
          >
            {{ linkSettings[accountPattern].businessService.text }}
          </DButton>
        </div>
      </div>
    </div>
    <div class="p-businessSectionContainer">
      <section class="p-businessCategory">
        <div class="p-businessMaxWidthContainer">
          <h2 class="p-businessSectionHeading">カテゴリ一覧</h2>
          <ul class="p-businessCategoryList">
            <li class="p-businessCategoryList_item">
              <!-- CSR遷移だとアンケート未回答の状態でもビジネストップ画面などを閲覧できてしまうため、SSRでnuxtServerInitを通し、アクセス許可対象のwhiteListチェックが必須（以下それぞれのカテゴリも同じ理由）  -->
              <SwitchLink
                link="/categories/18?is_business=1"
                :is-nuxt-link="!isBusiness"
                class="p-businessCategoryList_itemLink"
              >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/category-icon/category_18.svg')"
                  class="p-businessCategoryImage"
                  alt="デザイン"
                  loading="lazy"
                >
                <p class="p-businessCategoryList_text">デザイン</p>
              </SwitchLink>
            </li>
            <li class="p-businessCategoryList_item">
              <SwitchLink
                link="/categories/9?is_business=1"
                :is-nuxt-link="!isBusiness"
                class="p-businessCategoryList_itemLink"
              >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/category-icon/category_9.svg')"
                  class="p-businessCategoryImage"
                  alt="イラスト・漫画"
                  loading="lazy"
                >
                <p class="p-businessCategoryList_text">イラスト・漫画</p>
              </SwitchLink>
            </li>
            <li class="p-businessCategoryList_item">
              <SwitchLink
                link="/categories/22?is_business=1"
                :is-nuxt-link="!isBusiness"
                class="p-businessCategoryList_itemLink"
              >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/category-icon/category_22.svg')"
                  class="p-businessCategoryImage"
                  alt="Webサイト制作・Webデザイン"
                  loading="lazy"
                >
                <p class="p-businessCategoryList_text">Webサイト制作<br>・Webデザイン</p>
              </SwitchLink>
            </li>
            <li class="p-businessCategoryList_item">
              <SwitchLink
                link="/categories/23?is_business=1"
                :is-nuxt-link="!isBusiness"
                class="p-businessCategoryList_itemLink"
              >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/category-icon/category_23.svg')"
                  class="p-businessCategoryImage"
                  alt="音楽・ナレーション"
                  loading="lazy"
                >
                <p class="p-businessCategoryList_text">音楽・<br class="isSP">ナレーション</p>
              </SwitchLink>
            </li>
            <li class="p-businessCategoryList_item">
              <SwitchLink
                link="/categories/10?is_business=1"
                :is-nuxt-link="!isBusiness"
                class="p-businessCategoryList_itemLink"
              >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/category-icon/category_10.svg')"
                  class="p-businessCategoryImage"
                  alt="動画・アニメーション・撮影"
                  loading="lazy"
                >
                <p class="p-businessCategoryList_text">動画・アニメーション<br>・撮影</p>
              </SwitchLink>
            </li>
            <li class="p-businessCategoryList_item">
              <SwitchLink
                link="/categories/13?is_business=1"
                :is-nuxt-link="!isBusiness"
                class="p-businessCategoryList_itemLink"
              >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/category-icon/category_13.svg')"
                  class="p-businessCategoryImage"
                  alt="ビジネス代行・コンサル・士業"
                  loading="lazy"
                >
                <p class="p-businessCategoryList_text">ビジネス代行・コンサル<br>・士業</p>
              </SwitchLink>
            </li>
            <li class="p-businessCategoryList_item">
              <SwitchLink
                link="/categories/19?is_business=1"
                :is-nuxt-link="!isBusiness"
                class="p-businessCategoryList_itemLink"
              >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/category-icon/category_19.svg')"
                  class="p-businessCategoryImage"
                  alt="ライティング・翻訳"
                  loading="lazy"
                >
                <p class="p-businessCategoryList_text">ライティング・翻訳</p>
              </SwitchLink>
            </li>
            <li class="p-businessCategoryList_item">
              <SwitchLink
                link="/categories/11?is_business=1"
                :is-nuxt-link="!isBusiness"
                class="p-businessCategoryList_itemLink"
              >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/category-icon/category_11.svg')"
                  class="p-businessCategoryImage"
                  alt="IT・プログラミング・開発"
                  loading="lazy"
                >
                <p class="p-businessCategoryList_text">IT・プログラミング<br>・開発</p>
              </SwitchLink>
            </li>
            <li class="p-businessCategoryList_item">
              <SwitchLink
                link="/categories/16?is_business=1"
                :is-nuxt-link="!isBusiness"
                class="p-businessCategoryList_itemLink"
              >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/category-icon/category_16.svg')"
                  class="p-businessCategoryImage"
                  alt="マーケティング・Web集客"
                  loading="lazy"
                >
                <p class="p-businessCategoryList_text">マーケティング<br>・Web集客</p>
              </SwitchLink>
            </li>
          </ul>
        </div>
      </section>
      <section class="p-businessFeature">
        <h2 class="p-businessSectionHeading">ココナラビジネスの特徴</h2>
        <div class="p-businessFeatureContainerWrapper p-businessMaxWidthContainer">
          <div class="p-businessFeatureContainer">
            <div class="p-businessFeatureContent p-businessFeatureContent-service">
              <h3 class="p-businessFeatureContent_title">ビジネス利用向けに<br>厳選されたサービス</h3>
              <p class="p-businessFeatureContent_text isPC">
                {{ CONSTANTS_TEXT.CATEGORY_NUMBER }}種類以上の豊富なカテゴリからビジネス向けに厳選されたラインナップ。様々な価格、特徴、実績の業界プロ水準サービスを比較検討いただくことができます。
              </p>
            </div>
            <div class="p-businessFeatureImageWrapper p-businessFeatureImageWrapper-service">
              <div class="p-businessFeatureImageWrapperInner p-businessFeatureImageWrapperInner-service">
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/feature_04.png')"
                  class="isPC"
                  alt="service"
                  width="490"
                  height="355"
                  loading="lazy"
                >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/feature_04.png')"
                  class="isSP"
                  alt="service"
                  width="352"
                  loading="lazy"
                >
              </div>
            </div>
            <p class="p-businessFeatureContent_text isSP">
              {{ CONSTANTS_TEXT.CATEGORY_NUMBER }}種類以上の豊富なカテゴリからビジネス向けに厳選されたラインナップ。様々な価格、特徴、実績の業界プロ水準サービスを比較検討いただくことができます。
            </p>
          </div>
          <div class="p-businessFeatureContainer">
            <div class="p-businessFeatureContent p-businessFeatureContent-businessForms">
              <h3 class="p-businessFeatureContent_title">各種書類の発行が可能</h3>
              <p class="p-businessFeatureContent_text isPC">
                見積書・発注書・納品書・請求書・領収書などの帳票が発行できます。これにより、ビジネス上必要となる書類のダウンロード・印刷を、プラットフォーム内からスムーズに行うことができます。
              </p>
              <p class="p-businessFeatureContent_info isPC">
                ※請求書発行のご利用には、法人ドメインのメールアドレスによる申請と審査が必要です
              </p>
            </div>
            <div class="p-businessFeatureImageWrapper p-businessFeatureImageWrapper-businessForms">
              <div class="p-businessFeatureImageWrapperInner p-businessFeatureImageWrapperInner-businessForms">
                <img
                  src="~/assets/images/pages/business/lp/feature_08.png"
                  class="isPC"
                  alt="businessForms"
                  width="407"
                  height="317"
                  loading="lazy"
                >
                <img
                  src="~/assets/images/pages/business/lp/sp/feature_08.png"
                  class="isSP"
                  alt="businessForms"
                  width="315"
                  loading="lazy"
                >
              </div>
            </div>
            <p class="p-businessFeatureContent_text isSP">
              見積書・発注書・納品書・請求書・領収書などの帳票が発行できます。これにより、ビジネス上必要となる書類のダウンロード・印刷を、プラットフォーム内からスムーズに行うことができます。
            </p>
            <p class="p-businessFeatureContent_info isSP">
              ※請求書発行のご利用には、法人ドメインのメールアドレスによる申請と審査が必要です
            </p>
          </div>
          <div class="p-businessFeatureContainer">
            <div class="p-businessFeatureContent p-businessFeatureContent-invoice">
              <h3 class="p-businessFeatureContent_title">請求書払い・源泉徴収に対応</h3>
              <p class="p-businessFeatureContent_text isPC">
                クレジットカード払いや銀行振込に加え、請求書払いでの購入や、源泉徴収対象取引における徴収税額の自動計算が可能です。
              </p>
              <p class="p-businessFeatureContent_info isPC">※本機能のご利用には法人ドメインのメールアドレスによる申請と審査が必要です</p>
            </div>
            <div class="p-businessFeatureImageWrapper p-businessFeatureImageWrapper-invoice">
              <div class="p-businessFeatureImageWrapperInner p-businessFeatureImageWrapperInner-invoice">
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/feature_06.png')"
                  class="isPC"
                  alt="invoice"
                  width="316"
                  height="316"
                  loading="lazy"
                >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/feature_06.png')"
                  class="isSP"
                  alt="invoice"
                  width="298"
                  loading="lazy"
                >
              </div>
            </div>
            <p class="p-businessFeatureContent_text isSP">
              クレジットカード払いや銀行振込に加え、請求書払いでの購入や、源泉徴収対象取引における徴収税額の自動計算が可能です。請求書・領収書のオンライン確認・発行も対応しており、業務のご負担を軽減することができます。
            </p>
            <p class="p-businessFeatureContent_info isSP">
              ※本機能のご利用には法人ドメインのメールアドレスによる申請と審査が必要です
            </p>
          </div>
          <div class="p-businessFeatureContainer">
            <div class="p-businessFeatureContent p-businessFeatureContent-management">
              <h3 class="p-businessFeatureContent_title">チームでのご利用に便利な<br>管理機能が充実</h3>
              <p class="p-businessFeatureContent_text isPC">
                招待したチームメンバーのアカウント情報や取引状況・購入履歴を一元管理することができます。メンバーごとの権限設定もできるので、チーム単位で安心してご利用いただくことが可能です。
              </p>
            </div>
            <div class="p-businessFeatureImageWrapper p-businessFeatureImageWrapper-management">
              <div class="p-businessFeatureImageWrapperInner p-businessFeatureImageWrapperInner-management">
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/feature_01.png')"
                  class="isPC"
                  alt="management"
                  width="316"
                  height="317"
                  loading="lazy"
                >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/feature_01.png')"
                  class="isSP"
                  alt="management"
                  width="298"
                  loading="lazy"
                >
              </div>
            </div>
            <p class="p-businessFeatureContent_text isSP">
              招待したチームメンバーのアカウント情報や取引状況・購入履歴を一元管理することができます。メンバーごとの権限設定もできるので、チーム単位で安心してご利用いただくことが可能です。
            </p>
          </div>
          <div class="p-businessFeatureContainer">
            <div class="p-businessFeatureContent p-businessFeatureContent-project">
              <h3 class="p-businessFeatureContent_title">プロジェクトごとの案件管理や<br>メンバーアサイン</h3>
              <p class="p-businessFeatureContent_text isPC">
                プロジェクトを作成することで、プロジェクト単位で購入取引の進捗管理や、情報共有するメンバーの設定、出品者とのやりとりのチームメンバー閲覧が可能です。複数のプロジェクトが存在しても、取引管理の煩雑さを軽減することができます。
              </p>
            </div>
            <div class="p-businessFeatureImageWrapper p-businessFeatureImageWrapper-project">
              <div class="p-businessFeatureImageWrapperInner p-businessFeatureImageWrapperInner-project">
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/feature_02.png')"
                  class="isPC"
                  alt="project"
                  width="419"
                  height="316"
                  loading="lazy"
                >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/feature_02.png')"
                  class="isSP"
                  alt="project"
                  width="346"
                  loading="lazy"
                >
              </div>
            </div>
            <p class="p-businessFeatureContent_text isSP">
              プロジェクトを作成することで、プロジェクト単位で購入取引の進捗管理や、情報共有するメンバーの設定、出品者とのやりとりのチームメンバー閲覧が可能です。複数のプロジェクトが存在しても、取引管理の煩雑さを軽減することができます。
            </p>
          </div>
          <div class="p-businessFeatureContainer">
            <div class="p-businessFeatureContent p-businessFeatureContent-chat">
              <h3 class="p-businessFeatureContent_title">不明点はチャットで<br>リアルタイムに相談可能</h3>
              <p class="p-businessFeatureContent_text isPC">
                ご発注やご利用に関する疑問点は、チャットを通じてその場でご相談いただくことができます。お問合せフォームでのご相談もできるので、シーンに応じたサポートによるスムーズなお取引が可能です。
              </p>
              <p class="p-businessFeatureContent_info isPC">※チャット受付時間：平日10:30〜18:30</p>
            </div>
            <div class="p-businessFeatureImageWrapper p-businessFeatureImageWrapper-chat">
              <div class="p-businessFeatureImageWrapperInner p-businessFeatureImageWrapperInner-chat">
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/feature_05.png')"
                  class="isPC"
                  alt="chat"
                  width="352"
                  height="316"
                  loading="lazy"
                >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/feature_05.png')"
                  class="isSP"
                  alt="chat"
                  width="318"
                  loading="lazy"
                >
              </div>
            </div>
            <p class="p-businessFeatureContent_text isSP">
              ご発注やご利用に関する疑問点は、チャットを通じてその場でご相談いただくことができます。お問合せフォームでのご相談もできるので、シーンに応じたサポートによるスムーズなお取引が可能です。
            </p>
            <p class="p-businessFeatureContent_info isSP">※チャット受付時間：平日10:30〜18:30</p>
          </div>
          <div class="p-businessFeatureContainer">
            <div class="p-businessFeatureContent p-businessFeatureContent-online">
              <h3 class="p-businessFeatureContent_title">オンライン完結の<br>シンプルなEC型取引</h3>
              <div class="p-businessFeatureContent_text isPC">
                <p>
                  サービス・出品者の比較検討から相談・納品まで、簡単なステップでオンライン完結。時間や場所の制約を超えて全国の出品者からニーズに合う方をお選びいただくことで、ビジネス上の解決策の幅を広げることができます。
                </p>
              </div>
            </div>
            <div class="p-businessFeatureImageWrapper p-businessFeatureImageWrapper-online">
              <div class="p-businessFeatureImageWrapperInner p-businessFeatureImageWrapperInner-online">
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/feature_07.png')"
                  class="isPC"
                  alt="online"
                  width="488"
                  height="316"
                  loading="lazy"
                >
                <img
                  :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/feature_07.png')"
                  class="isSP"
                  alt="online"
                  width="359"
                  loading="lazy"
                >
              </div>
            </div>
            <p class="p-businessFeatureContent_text isSP">
              サービス・ユーザーの比較検討から相談・納品までが、簡単なステップでオンライン完結。時間や場所の制約を超えて全国の出品者からニーズに合う方にご相談頂くことで、ビジネス上の解決策の幅を広げることができます。
            </p>
          </div>
        </div>
      </section>
      <section class="p-businessUserFlowBtnWrapper p-businessUserFlowBtnWrapper-separator">
        <DButton
          v-if="isShowMultipleButton"
          :class="{'p-businessUserFlowBtnWrapper_button-multiple': isShowMultipleButton}"
          class="p-businessUserFlowBtnWrapper_button"
          :href="userOuterFlowButton.REGISTER.link"
          type="contained"
          color="primary"
          size="large"
          is-bold
        >
          {{ userOuterFlowButton.REGISTER.text }}
        </DButton>
        <!-- CSR遷移だとアンケート未回答の状態でもビジネストップ画面などを閲覧できてしまうため、SSRでnuxtServerInitを通し、アクセス許可対象のwhiteListチェックが必須 -->
        <DButton
          class="p-businessUserFlowBtnWrapper_button"
          :href="linkSettings[accountPattern].businessService.link"
          type="outlined"
          color="primary"
          size="large"
          is-bold
        >
          {{ linkSettings[accountPattern].businessService.text }}
        </DButton>
      </section>
      <section class="p-businessSafety">
        <h2 class="p-businessSectionHeading">安心・安全の仕組み</h2>
        <div class="p-businessMaxWidthContainer">
          <div class="p-businessSafetyContent">
            <div class="p-businessSafetyContent_item">
              <img
                :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/safety_01.png')"
                alt=""
                width="250"
                height="250"
                loading="lazy"
              >
              <h3 class="p-businessSafetyContent_title">出品者の本人確認・NDA</h3>
              <p class="p-businessSafetyContent_text">
                出品者は全員本人確認を実施済み<br>
                運営との機密保持契約も締結しており、<br>
                信頼性の高い方に依頼することが可能です。
              </p>
            </div>
            <div class="p-businessSafetyContent_item">
              <img
                :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/safety_02.png')"
                alt=""
                width="250"
                height="250"
                loading="lazy"
              >
              <h3 class="p-businessSafetyContent_title">365日の監視体制</h3>
              <p class="p-businessSafetyContent_text">
                専任スタッフによる365日体制のお問合せ対応や<br>
                サービス監視を実施し、安心してお取引できる<br>
                管理体制を構築しております。
              </p>
            </div>
            <div class="p-businessSafetyContent_item">
              <img
                :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/safety_03.png')"
                alt=""
                width="250"
                height="250"
                loading="lazy"
              >
              <h3 class="p-businessSafetyContent_title">自動付帯の賠償責任保険</h3>
              <p class="p-businessSafetyContent_text">
                万が一のケースに対しても賠償責任保険が<br>
                無料で自動付帯されるので安心です。<br>
                <a
                  :href="$coconala.helpURL('/articles/4430829858201')"
                  target="_blank"
                  rel="noopener"
                >
                  > 詳しくはこちら
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="p-businessCustomer">
        <h2 class="p-businessSectionHeading">お客様の声</h2>
        <DBusinessCustomerVoice />
      </section>
      <section class="p-businessPrice">
        <h2 class="p-businessSectionHeading">ご利用料金</h2>
        <div class="p-businessMaxWidthContainer">
          <div class="p-businessPriceContainer">
            <div class="p-businessPriceContent">
              <p class="p-businessPriceContent_title">登録・利用は無料</p>
              <p class="p-businessPriceContent_text">
                <span class="p-businessPriceContent_price">0</span>円
              </p>
            </div>
            <div class="p-businessPriceFeatures">
              <ul class="p-businessPriceFeatures_list">
                <li class="p-businessPriceFeatures_item">
                  <span class="p-businessPriceFeatures_icon">
                    <CoconalaIcon
                      name="check-circle"
                      size="20px"
                      color="ds2Primary"
                    />
                  </span>
                  チーム管理機能
                </li>
                <li class="p-businessPriceFeatures_item">
                  <span class="p-businessPriceFeatures_icon">
                    <CoconalaIcon
                      name="check-circle"
                      size="20px"
                      color="ds2Primary"
                    />
                  </span>
                  プロジェクト管理機能
                </li>
                <li class="p-businessPriceFeatures_item">
                  <span class="p-businessPriceFeatures_icon">
                    <CoconalaIcon
                      name="check-circle"
                      size="20px"
                      color="ds2Primary"
                    />
                  </span>
                  請求書払い・源泉徴収対応
                </li>
                <li class="p-businessPriceFeatures_item">
                  <span class="p-businessPriceFeatures_icon">
                    <CoconalaIcon
                      name="check-circle"
                      size="20px"
                      color="ds2Primary"
                    />
                  </span>
                  リアルタイムチャットサポート
                </li>
                <li class="p-businessPriceFeatures_item">
                  <span class="p-businessPriceFeatures_icon">
                    <CoconalaIcon
                      name="check-circle"
                      size="20px"
                      color="ds2Primary"
                    />
                  </span>
                  ビジネス向けの厳選サービス
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="p-businessUserFlowBtnWrapper">
          <DButton
            v-if="isShowMultipleButton"
            :class="{'p-businessUserFlowBtnWrapper_button-multiple': isShowMultipleButton}"
            class="p-businessUserFlowBtnWrapper_button"
            :href="userOuterFlowButton.REGISTER.link"
            type="contained"
            color="primary"
            size="large"
            is-bold
          >
            {{ userOuterFlowButton.REGISTER.text }}
          </DButton>
          <!-- CSR遷移だとアンケート未回答の状態でもビジネストップ画面などを閲覧できてしまうため、SSRでnuxtServerInitを通し、アクセス許可対象のwhiteListチェックが必須 -->
          <DButton
            class="p-businessUserFlowBtnWrapper_button"
            :href="linkSettings[accountPattern].businessService.link"
            type="outlined"
            color="primary"
            size="large"
            is-bold
          >
            {{ linkSettings[accountPattern].businessService.text }}
          </DButton>
        </div>
      </section>
      <section class="p-businessQa">
        <h2 class="p-businessSectionHeading">よくあるご質問</h2>
        <div class="p-businessMaxWidthContainer">
          <DAccordion
            question="ココナラビジネスを利用するのにお金がかかりますか？"
            answer="
              ご登録・ご利用は無料です。<br class='isSP'>無料で簡単にアカウントを作成することができ、登録直後からご利用いただけます。
            "
          />
          <DAccordion
            question="ココナラとココナラビジネスの違いはなんですか？"
            answer="
              ココナラビジネスはビジネス用途の購入向けに特化したプラットフォームです。<br>
              請求書払い（Paid）・源泉徴収機能・チャットによるサポートをご利用いただけるほか、ビジネス向けに厳選されたラインナップより業界プロ水準のサービスをお選びいただくことができます。<br>
              プライベート用途の購入やサービスの出品・販売はココナラをご利用ください。<br>
              詳しくは<a class='d-accordion-link' href='https://coconala-support.zendesk.com/hc/ja/articles/360020926033' target='_blank' rel='noopener'>こちら</a>"
          />
          <DAccordion
            question="個人アカウントとは別にココナラビジネスのアカウントを作ることはできますか？"
            answer="
              できます。現在の個人アカウントを保有したまま新たにココナラビジネスのアカウントを作る場合、今後は２つのアカウントを切り替えながら用途に応じて使い分けることが可能です。<br>
              詳しくは<a class='d-accordion-link' href='https://coconala-support.zendesk.com/hc/ja/articles/360020926293' target='_blank' rel='noopener'>こちら</a>
            "
          />
          <DAccordion
            question="ビジネスに利用できる品質の納品がされますか？"
            answer="
              ビジネス向けにサービスを厳選しているほか、業界のプロフェッショナルが責任を持って対応するPRO認定サービスがございます。<br>
              「品質」「納期」「情報管理」などの基準を満たしたサービスや出品者がわかりやすく可視化されているため、より品質が高い方を比較検討の上お選びいただけます。<br>
              詳しくは<a class='d-accordion-link' href='https://coconala.com/pages/about_pro' target='_blank' rel='noopener'>こちら</a>
            "
          />
          <DAccordion
            question="支払い方法の種類を教えてください"
            answer="
              クレジットカード、銀行振込、請求書払い（Paid）をご利用いただけます。<br>
              請求書払い（Paid）のご利用には法人ドメインのメールアドレスによる申請と審査が必要となります。<br>
              詳しくは<a class='d-accordion-link' href='https://coconala-support.zendesk.com/hc/ja/articles/360020926093' target='_blank' rel='noopener'>こちら</a>
            "
          />
          <DAccordion
            question="実際の取引の流れを教えてください"
            answer="
              1. サービスを探す、2. サービスを購入する、3. 出品者とやりとりして納品してもらうといった、オンライン完結のシンプルな取引です。<br>
              詳しくは<a class='d-accordion-link' href='https://coconala.com/pages/guide_buy' target='_blank' rel='noopener'>こちら</a><br>
              出品されているサービスを探して購入する方法以外にも、要件を伝えた上で見積りをとってから購入する方法もございます。<br>
              詳しくは<a class='d-accordion-link' href='https://coconala-support.zendesk.com/hc/ja/articles/360004600633' target='_blank' rel='noopener'>こちら</a>"
          />
          <DAccordion
            question="セキュリティ対策が気になります"
            answer="
              機密保持についてはココナラ利用規約で定められており、ご利用いただく方全員に利用規約に同意していただいております。<br>
              さらに、ココナラと機密保持契約（NDA）を締結している出品者はページ内に表示されるようになっており、すぐに確認できるため安心です。<br>
              また、ココナラではSSLサーバ証明書を取得しており、データベース内ではパスワードを暗号化して保存するなど、システム保守に万全を期しています。
            "
          />
        </div>
        <p class="p-businessQa_linkWrap">
          <a
            class="p-businessQa-link"
            href="https://coconala-support.zendesk.com/hc/ja"
            target='_blank'
            rel='noopener'
          >
            &gt; その他のご質問はこちら
          </a>
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import DAccordion from '~/components/atoms/DS2/DAccordion'
import DButton from '~/components/atoms/DS2/DButton'
import DBusinessCustomerVoice from '~/components/organisms/DS2/DBusinessCustomerVoice'
import DLabel from '~/components/atoms/DS2/DLabel'
import SwitchLink from '~/components/atoms/SwitchLink'
import { mapState, mapGetters, mapMutations } from 'vuex'
import businessMixin from '~/mixins/pages/business-mixin'
import { BUSINESS_DOCUMENT_DOWNLOAD_LINK } from '~/constants/urls'

const SEO = {
  CANONICAL: 'https://coconala.com/business/',
  DESCRIPTION:
    'ココナラビジネスは、あらゆるジャンルのプロフェッショナルにオンラインで簡単に依頼ができるスキルマーケットです。WEBサイト制作や動画編集、マーケティングやビジネス相談などあなたの依頼内容にぴったりのプロフェッショナルが見つかります。',
  KEYWORDS: 'ビジネス,スキルマーケット,スキルシェア,マーケットプレイス,ココナラ,coconala,ここなら'
}

/** @type {import('vue').ComponentOptions} */
const business = {
  name: 'business',
  mixins: [businessMixin],
  components: {
    DAccordion,
    DButton,
    DBusinessCustomerVoice,
    DLabel,
    SwitchLink
  },
  layout: 'businessLp',
  middleware: ['endsWithSlash'],
  head() {
    const metaTitle = this.genMetaTitle('ココナラビジネス', 'あなたのチームにプロフェッショナルを')
    const metaDescription = this.genMetaDescription(SEO.DESCRIPTION)
    const ogpUrl = this.$coconala.url(this.$route.path)
    const keywords = this.genMetaKeywords(SEO.KEYWORDS)
    const robots = this.genMetaRobots('index,follow')
    const type = this.genMetaType('website')
    const siteName = this.genMetaSiteName()
    return {
      title: metaTitle,
      link: [{ rel: 'canonical', href: SEO.CANONICAL }],
      meta: [
        metaDescription,
        keywords,
        robots,
        ...this.genOGP(ogpUrl, type, metaTitle, metaDescription.content, siteName, null)
      ]
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapState('auth/user', ['isBusiness']),
    ...mapGetters('ui', ['isSP']),
    // アカウントの状態によってリンク出しわけ
    linkSettings() {
      return {
        // 未ログイン
        PATTERN_A: {
          isProviderOrPrivateBuyer: true,
          businessTopLink: '/business/top',
          businessService: {
            link: '/business/top',
            text: 'サービスを見てみる'
          },
          registerButton: {
            text: '無料で会員登録する',
            link: '/business/register'
          }
        },
        // ビジネスアカウントログイン中
        PATTERN_B: {
          isProviderOrPrivateBuyer: false,
          businessTopLink: '/',
          businessService: {
            link: '/',
            text: 'サービスを見てみる'
          }
        },
        // 個人・出品アカウントログイン中 かつ
        // ビジアカひもづきなし または
        // ビジアカひもづきあり、かつビジアカログイン中セッションなし
        PATTERN_C: {
          isProviderOrPrivateBuyer: false,
          businessTopLink: '/business/top',
          businessService: {
            link: '/business/top',
            text: 'サービスを見てみる'
          },
          registerButton: {
            text: '無料で会員登録する',
            link: '/business/register'
          }
        },
        // 個人・出品アカウントログイン中 かつ
        // 裏でビジアカログインセッションあり
        PATTERN_D: {
          isProviderOrPrivateBuyer: false,
          businessService: {
            link: '/business/top',
            text: 'サービスを見てみる'
          }
        }
      }
    },
    userOuterFlowButton() {
      return {
        REGISTER: {
          text: '無料で会員登録する',
          link: '/business/register'
        },
        DOWNLOAD: {
          text: '資料をダウンロード',
          link: BUSINESS_DOCUMENT_DOWNLOAD_LINK
        }
      }
    },
    accountPattern() {
      // 未ログインの場合
      if (!this.isLoggedIn) {
        return 'PATTERN_A'
      }

      // ビジネスアカウントでログイン中の場合
      const isUserBusinessAccount = this.$store.state.auth?.user?.isBusiness
      if (isUserBusinessAccount) {
        return 'PATTERN_B'
      }

      const existsBusinessAccountInfo = !!Object.keys(
        this.$store.state.my.header.businessAccountInfo
      ).length
      const isBusinessAccountLoggendIn = this.$store.state.my?.header?.businessAccountInfo?.isLogin
      // ビジネスアカウントのひも付けがない場合
      // またはビジネスアカウントのひも付けがあり、かつビジアカログイン中セッションがない場合
      if (!existsBusinessAccountInfo || !isBusinessAccountLoggendIn) {
        return 'PATTERN_C'
      }
      // 上記からログインセッションがある場合
      return 'PATTERN_D'
    },
    isShowMultipleButton() {
      return ['PATTERN_A', 'PATTERN_C'].includes(this.accountPattern)
    },
    CONSTANTS_TEXT() {
      return {
        USER_NUMBER: '220万',
        CATEGORY_NUMBER: '230',
        SERVICE_NUMBER: '40万'
      }
    }
  },
  methods: {
    ...mapMutations('pages/business/lp', ['SET_ACCOUNT_BUTTON_POSITION', 'SET_ACCOUNT_PATTERN'])
  },
  created() {
    this.SET_ACCOUNT_PATTERN(this.accountPattern)
  },
  mounted() {
    this.SET_ACCOUNT_BUTTON_POSITION(this.$refs.accountButton.getBoundingClientRect().top)

    // ビジネスアカウントログイン中でもこの画面はZendesk widgetを表示しない
    if (typeof zE === 'function') {
      zE('webWidget', 'hide')
    }
  },
  beforeDestroy() {
    if (typeof zE === 'function') {
      zE('webWidget', 'show')
    }
  }
}
export default business
</script>

<style lang="scss" scoped>
// PC
.isSP {
  display: none;
}

.p-businessSectionHeading {
  position: relative;
  margin-bottom: 70px;
  color: $ds2-color-gray-900;
  text-align: center;
  font-weight: bold;
  font-size: 32px;
  &::before {
    position: absolute;
    top: 60px;
    right: 0;
    bottom: 0;
    left: 0;
    display: inline-block;
    margin: 0 auto;
    width: 200px;
    height: 4px;
    background: $ds2-color-brand-primary;
    content: '';
  }
}

.p-businessMaxWidthContainer {
  margin: 0 auto;
  max-width: 952px;
}

.p-businessUserFlowBtnWrapper {
  display: flex;
  margin: 0 auto;

  align-items: center;
  justify-content: center;

  &-separator {
    padding: 64px 0;
    background-color: $ds2-color-gray-10;
  }

  &_button {
    max-width: 328px;
    width: 100%;
    &-multiple {
      margin-right: 20px;
    }
    /deep/ .d-button_text {
      font-size: 18px;
    }
  }
}

.p-businessMain {
  position: relative;
  background-color: $ds2-color-business-lp-primary;
  height: 580px;
  &-link {
    @include link-effect;
    color: $ds2-color-white;
  }
}

.p-businessMainInner {
  display: flex;
  padding: 0 36px;
  max-width: 1400px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
}

.p-businessMainImageList {
  display: flex;
  width: 696px;
  height: 330px;
  margin: 60px auto 0;
}

.p-businessMainHeading {
  margin-top: 50px;
  margin-right: 40px;
  color: $ds2-color-white;
  &_title {
    margin-bottom: 10px;
    font-size: 52px;
    font-weight: bold;
  }
  &_text {
    font-size: 15px;
    margin-bottom: 40px;
  }
  &_button {
    &-single {
      width: 396px;
    }
    &-multiple {
      width: 248px;
      &:last-child {
        margin-left: 24px;
      }
    }
  }
  /deep/ .d-button_text {
    font-size: 16px;
  }
}

.p-businessMainBtnWrapper {
  display: flex;
}

.p-businessMainDownload {
  position: absolute;
  right: 0;
  left: 0;
  display: flex;
  margin: -51px auto 0;
  padding: 21px 0;
  max-width: 1080px;
  width: 100%;
  border-radius: 6px;
  background: $ds2-color-white;
  box-shadow: 0 2px 6px rgba(2, 16, 66, 0.1);

  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  &_image {
    width: 138px;
  }
  &_text {
    margin: 0 20px 0 32px;
    color: $ds2-color-business-navy-800;
    font-weight: bold;
    font-size: 15px;
  }
  &_button {
    /deep/ .d-button_text {
      font-size: 15px;
    }
  }
}

.p-businessSponsor {
  padding: 106px 0 38px;
  background-color: $ds2-color-gray-10;
}

.p-businessSponsorHeading {
  margin-bottom: 36px;
  color: $ds2-color-gray-700;
  font-weight: bold;
  text-align: center;
}

.p-businessSponsorList {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: auto 1fr;
  max-width: 1200px;
  margin: 0 auto;
  &_item {
    max-width: 200px;
    width: 100%;
    margin-bottom: 20px;
  }
}

.p-businessAbout {
  padding: 60px 0;
  &_inner {
    display: flex;
    margin: 0 auto;
    justify-content: center;
  }
}

.p-businessAboutImageWrapper {
  max-width: 326px;
  width: 100%;
}

.p-businessAboutButton {
  text-align: center;
  width: 173px;
  /deep/ .d-button_text {
    font-size: 15px;
  }
}

.p-businessAboutContent {
  max-width: 502px;
  margin-left: 125px;
  padding-top: 40px;
  &_subtitle {
    margin: 0 0 13px 0;
    color: $ds2-color-business-navy-200;
    font-size: 16px;
    font-weight: bold;
  }
  &_title {
    margin-bottom: 15px;
    color: $ds2-color-business-navy-800;
    font-size: 32px;
    font-weight: bold;
  }
  &_text {
    font-size: 15px;
    margin-bottom: 40px;
    color: $ds2-color-gray-700;
  }
}

.p-businessCategory {
  padding: 60px 0 40px;
  background-color: $ds2-color-gray-10;
}

.p-businessCategoryImage {
  width: 60px;
  height: auto;
  margin-bottom: 15px;
  filter: drop-shadow(2px 2px 0 rgba(0, 0, 0, 0.1));
}

.p-businessCategoryList {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  &_item {
    width: 20%;
    display: flex;
    margin-bottom: 30px;
    flex-direction: column;
    align-items: center;
  }
  &_text {
    color: $ds2-color-gray-700;
    font-weight: bold;
    text-align: center;
  }
  &_itemLink {
    @include link-effect;
    text-align: center;
  }
}

.p-businessFeature {
  padding: 60px 0;
}

.p-businessFeatureContainerWrapper {
  :nth-child(odd) {
    flex-direction: row-reverse;
  }
}

.p-businessFeatureContent {
  padding-top: 40px;

  &_title {
    margin-bottom: 30px;
    color: $ds2-color-business-navy-800;
    font-weight: bold;
    font-size: 28px;
  }
  &_text {
    color: $ds2-color-gray-900;
    font-size: 15px;
    letter-spacing: 0.05em;
  }
  &_info {
    color: $ds2-color-gray-900;
    font-size: 12px;
  }
  &_notice {
    margin-bottom: 5px;
    border-radius: 2px;
  }
  &-service {
    margin-left: auto;
    max-width: 440px;
  }
  &-management {
    margin-right: auto;
    max-width: 480px;
  }
  &-businessForms {
    margin-right: 32px;
    max-width: 545px;
  }
  &-project {
    margin-left: auto;
    max-width: 500px;
  }
  &-information {
    flex-direction: column;
    margin-right: auto;
    max-width: 500px;
  }
  &-chat {
    margin-right: auto;
    max-width: 530px;
  }
  &-invoice {
    margin-left: auto;
    max-width: 545px;
  }
  &-online {
    margin-left: auto;
    max-width: 420px;
  }
}

.p-businessFeatureContainer {
  display: flex;
  margin: 0 auto 90px;

  justify-content: center;
  &:last-child {
    margin-bottom: 40px;
  }
}

.p-businessSafety {
  padding: 60px 0;
}

.p-businessSafetyContent {
  display: flex;

  justify-content: space-between;

  &_item {
    text-align: center;
  }

  &_title {
    margin: 8px 0;
    color: $ds2-color-business-navy-800;
    font-weight: bold;
    font-size: 20px;
  }

  &_text {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;

    a {
      @include link-effect;
    }
  }
}

.p-businessCustomer {
  padding: 60px 0 40px;
  background-color: $ds2-color-gray-10;
}

.p-businessPrice {
  padding: 60px 0;
}

.p-businessPriceContainer {
  display: flex;
  margin: 0 auto 70px;
  padding: 28px 0;
  border-radius: 8px;
  background: $ds2-color-brand-primary-100;
  justify-content: center;
}

.p-businessPriceContent {
  width: 50%;
  text-align: center;
  border-right: 1px solid $ds2-color-gray-100;
  color: $ds2-color-brand-primary;
  font-weight: bold;
  &_title {
    font-size: 24px;
  }
  &_text {
    font-size: 32px;
  }
  &_price {
    color: $ds2-color-brand-primary;
    font-size: 120px;
    font-weight: bold;
    line-height: 100px;
  }
}

.p-businessPriceFeatures {
  width: 50%;
  text-align: center;
  padding: 10px 0;
  &_list {
    padding-left: 40px;
    text-align: left;
  }
  &_item {
    margin-bottom: 20px;
    font-size: 15px;
    font-weight: bold;
    color: $ds2-color-gray-900;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &_icon {
    margin-right: 10px;
  }
}

.p-businessQa {
  margin-bottom: -60px;
  padding: 60px 0 80px;
  background-color: $ds2-color-gray-10;
  /deep/ .d-accordion {
    &-link {
      @include link-effect;
      color: $ds2-color-gray-700;
      text-decoration: underline;
    }
    .isSP {
      display: none;
    }
  }
  &_linkWrap {
    margin-bottom: 0;
    font-size: 16px;
    text-align: center;
  }
  &-link {
    @include link-effect;
    color: $ds2-color-brand-secondary;
  }
}

// main内innerのwidth
@media (max-width: 1328px) {
  .p-businessMainHeading {
    &_title {
      width: 520px;
      font-size: 48px;
    }
  }
}

@media (max-width: breakpoint(BusinessTop, M)) {
  .p-businessMainHeading {
    &_title {
      font-size: 44px;
    }
  }

  .p-businessAboutContent {
    margin-left: 40px;
    &_title {
      font-size: 28px;
    }
  }

  .p-businessCategoryList {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto 1fr;
    &_item {
      width: 100%;
    }
  }

  .p-businessCategoryImage {
    width: 48px;
  }
}

@media (max-width: 1180px) {
  .p-businessMainInner {
    overflow: hidden;
  }
}

@media (max-width: 952px) {
  .p-businessMaxWidthContainer {
    padding: 0 20px;
  }

  .p-businessFeature {
    padding: 60px 0 40px;
  }

  .p-businessFeatureContent {
    &-service {
      width: 45%;
    }
    &-management {
      width: 48%;
    }
    &-businessForms {
      width: 48%;
    }
    &-project {
      width: 55%;
    }
    &-information {
      width: 50%;
    }
    &-chat {
      width: 62%;
    }
    &-invoice {
      width: 66%;
    }
    &-online {
      width: 50%;
    }
  }

  .p-businessFeatureImageWrapper {
    &-service {
      width: 50%;
    }
    &-management {
      width: 47%;
    }
    &-businessForms {
      width: 47%;
    }
    &-project {
      width: 40%;
    }
    &-information {
      width: 45%;
    }
    &-chat {
      width: 33%;
    }
    &-invoice {
      width: 29%;
    }
    &-online {
      width: 45%;
    }
  }

  .p-businessCustomerInfo {
    max-height: unset;
    height: 150px;
  }
}

// SP
@media (max-width: breakpoint(BusinessTop, S)) {
  .isPC {
    display: none;
  }

  .isSP {
    display: block;
  }

  .p-businessSectionHeading {
    margin-bottom: 60px;
    font-size: 24px;
    &::before {
      width: 140px;
      top: 50px;
    }
  }

  .p-businessUserFlowBtnWrapper {
    display: block;
    padding: 0 20px;
    text-align: center;

    &-separator {
      padding: 32px 20px;
    }

    &_button {
      &-multiple {
        margin-right: 0;
        margin-bottom: 20px;
      }
      /deep/ .d-button_text {
        font-size: 15px;
      }
    }
  }

  .p-businessMain {
    height: auto;
    &_link {
      color: $ds2-color-white;
    }
  }

  .p-businessMainHeading {
    width: 100%;
    margin-top: 0;
    padding-top: 100px;
    text-align: center;
    &_title {
      width: 100%;
      font-size: 32px;
    }
    &_text {
      margin-bottom: 25px;
    }
    &_button {
      &-multiple {
        width: 100%;
        &:first-child {
          margin-bottom: 24px;
        }
        &:last-child {
          margin-left: 0;
        }
      }
      &-single {
        width: 100%;
      }
    }
  }

  .p-businessMainInner {
    display: block;
    position: relative;
    min-width: unset;
    width: 100%;
    align-items: unset;
  }

  .p-businessMainLinkWrapper {
    margin-top: 20px;
    padding: 0 24px;
    &_text {
      text-align: center;
      text-decoration: underline;
    }
  }

  .p-businessMainBtnWrapper {
    display: block;
    max-width: 319px;
    width: 100%;
    margin: 0 auto 30px;
  }

  .p-businessMainDownload {
    position: relative;
    margin-top: -35px;
    padding: 34px 20px;
    border-radius: 0;
    box-shadow: none;
    &_text {
      width: 100%;
      text-align: center;
      margin-bottom: 20px;
    }
    &_button {
      max-width: 328px;
      width: 100%;
    }
  }

  .p-businessMainImageWrapper {
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    max-width: unset;
    width: 100%;
  }

  .p-businessMainImageList {
    width: 100%;
    height: auto;
    margin: 0 auto 0;
    justify-content: center;
    &_item {
      width: 191px;
      &:nth-child(2),
      &:nth-child(3) {
        margin-left: -56px;
      }
    }
  }

  .p-businessSponsor {
    padding: 24px 0;
  }

  .p-businessSponsorList {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto 1fr;
    &_item {
      height: 70px;
    }
  }

  .p-businessAbout {
    &_inner {
      display: block;
      max-width: 400px;
    }
  }

  .p-businessAboutContent {
    width: 100%;
    margin-left: 0;
    padding-top: 0;
    text-align: center;
    &_title {
      font-size: 22px;
    }
    &_text {
      margin-bottom: 32px;
    }
  }

  .p-businessAboutImageWrapper {
    width: 100%;
    margin: 0 auto 30px;
  }

  .p-businessAboutButton {
    max-width: 328px;
    width: 100%;
  }

  .p-businessCategoryList {
    &_item {
      margin-bottom: 10px;
      padding: 10px 15px;
    }
  }

  .p-businessCategoryText {
    font-size: 11px;
  }

  .p-businessFeatureHeading {
    font-size: 24px;
  }

  .p-businessFeatureContainer {
    display: block;
    margin: 0 auto 50px;
    max-width: 400px;
    width: 100%;
  }

  .p-businessFeatureImageWrapper {
    margin: 0 auto 20px;
    width: 100%;

    &-service {
      max-width: 352px;
    }
    &-management {
      max-width: 298px;
    }
    &-businessForms {
      max-width: 315px;
    }
    &-project {
      max-width: 346px;
    }
    &-information {
      max-width: 357px;
    }
    &-chat {
      max-width: 318px;
    }
    &-invoice {
      max-width: 298px;
    }
    &-online {
      max-width: 359px;
    }
  }

  .p-businessFeatureImageWrapperInner {
    position: relative;
    img {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      margin: auto;
    }
    &-service {
      padding-top: 100% * 299 / 352;
    }
    &-management {
      padding-top: 100% * 316 / 298;
    }
    &-businessForms {
      padding-top: 100% * 237 / 298;
    }
    &-project {
      padding-top: 100% * 299 / 346;
    }
    &-information {
      padding-top: 100% * 299 / 357;
    }
    &-chat {
      padding-top: 100% * 299 / 318;
    }
    &-invoice {
      padding-top: 100% * 299 / 298;
    }
    &-online {
      padding-top: 100% * 299 / 359;
    }
  }

  .p-businessFeatureContent {
    display: flex;
    flex-direction: column !important;
    margin: 0 auto;
    padding-top: 0;
    padding-right: 0;
    padding-left: 0;
    width: 100%;

    justify-content: center;

    &_title {
      width: 100%;
      text-align: center;
      font-size: 22px;
    }
    &_notice {
      margin: 0 auto 10px;
    }
  }

  .p-businessSafetyContent {
    display: block;

    &_item {
      & + & {
        margin-top: 40px;
      }
    }
  }

  .p-businessCustomerList {
    overflow-x: scroll;
    // ios用
    -webkit-overflow-scrolling: touch;
    margin-bottom: 30px;

    justify-content: unset;
    &_item {
      padding-bottom: 10px;
      min-width: 200px;
    }
  }

  .p-businessCustomerInfo {
    height: 160px;
  }

  .p-businessPriceContainer {
    display: block;
    margin: 0 auto 40px;
    padding: 25px 30px;
  }

  .p-businessPriceContent {
    width: 100%;
    margin-bottom: 20px;
    border-right: none;
    border-bottom: 1px solid $ds2-color-gray-100;
    &_title {
      margin-bottom: 10px;
      font-size: 20px;
    }
    &_text {
      margin-bottom: 30px;
      font-size: 32px;
    }
    &_price {
      font-size: 80px;
    }
  }

  .p-businessPriceFeatures {
    width: 100%;
    padding: 0;
    &_list {
      padding-left: 0;
    }
  }

  .p-businessQa {
    margin-bottom: 0;
    padding: 88px 0 60px;
    /deep/ .d-accordion {
      .isSP {
        display: block;
      }
    }
  }
}

@media (max-width: 390px) {
  .p-businessMainHeading {
    &_title {
      font-size: 26px;
    }
  }
}

@media (max-width: 320px) {
  .p-businessMainHeading {
    &_title {
      font-size: 24px;
    }
  }
}
</style>
